import { configOptions } from "final-form";
import moment from "moment";
import {
  SET_MYCORRECTIONREQ_LOADING,
  SET_MYCORRECTIONREQ,
  ADD_CORRECTIONREQ,
  DELETE_MY_CORRECTION_REQUEST
} from "./constants";

const initialState = {
  isLoading: true,
  myCorrectionReq: [],
}

const Reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_MYCORRECTIONREQ_LOADING:
      return {
        ...state,
        isLoading: payload
      };
      case SET_MYCORRECTIONREQ:
        return {
          ...state,
          isLoading: false,
          myCorrectionReq: payload.result,
          totalPage:payload.totalPages
        };
      case DELETE_MY_CORRECTION_REQUEST:
          return {
            ...state,
            isLoading: false,
            correctionData: state.myCorrectionReq.filter((item) => item._id !== payload)
        }
    default:
      return state;
  }
};

export default Reducer;